export default __webpack_public_path__ + "static/natural2-7f4ce6aecae18b48b21640066b9c6d2f.jpg";